import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { connect } from 'react-redux';

import { openLogInModal, openSignUpModal } from '../../../../redux/modals';
import { closeAccountDrawer, logout } from '../../../../redux/account';
import colors from '../../../../styling/colors';
import typography from '../../../../styling/mixins/typography';
import TakeoverDrawer from '../../SiteTakeovers/TakeoverDrawer';
import User from '../../../../assets/svg/User';
import envelope from '../../../../assets/images/envelope.png';
import DefaultButton from '../../Buttons/DefaultButton';
import takeover from '../../../../hocs/takeover';
import HandOffLink from '../../../../utils/urls/HandOffLink';
import withTrackingPropsProvider from '../../../../hocs/withTrackingPropsProvider';
import {
  isLoggedIn,
  accountDisplayName,
  accountEmail,
} from '../../../../utils/selectors/account';
// TODO: move this into this file?
import SmallcapsHeader from '../../Titles/SmallcapsHeader';

const DrawerItems = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const Item = styled.li`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 5.5rem;
  padding: 1rem;
  background: ${colors('dove')};
`;

const Profile = styled.div`
  display: flex;
`;

const Icon = styled.div`
  margin-right: 1rem;
`;

const LoggedInIcon = styled.div`
  margin-right: 1rem;
  margin-right: 0.75rem;
  border-radius: 3rem;
  width: 3rem;
  height: 3rem;
  padding: 0.8rem;
  background: ${colors('alto')};
`;

const Info = styled.div`
  border: none;
`;

const UserName = styled.div`
  color: ${colors('lapel')};
  ${typography.BasisFont};
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5rem;
  margin-top: 0.35rem;
`;

const Email = styled.div`
  color: ${colors('dustyGray')};
  ${typography.BasisFont};
  font-size: 0.75rem;
  font-weight: lighter;
`;

const Nav = styled.div`
  margin-top: 1.5rem;
  margin-left: 1rem;
  line-height: 1rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Link = styled(HandOffLink)`
  ${typography.BasisFont};
  font-weight: lighter;
  font-size: 1rem;
  margin-bottom: 1rem;
`;

const LinkWrapper = styled.div`
  border-bottom: solid 1px ${colors('gallery')};
  color: ${colors('lapel')};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  line-height: 1.5rem;
  margin-left: -1rem;
  padding: 1rem 0 0 1rem;
`;

const Logout = styled.li`
  list-style: none;
  margin-bottom: 1rem;
`;

const Container = styled.div`
  margin: 0 1rem;
`;

const TextContainer = styled.div`
  margin: 1.5rem 0 1.25rem;
`;

const Header = styled.h2`
  font-weight: bold;
  font-size: 0.75rem;
  letter-spacing: 0.125rem;
  margin: 1rem 0;
  text-transform: uppercase;
`;

const Paragraph = styled.div`
  display: flex;
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0;
`;

const Button = styled(DefaultButton)`
  width: 100%;
`;

const Image = styled.img`
  height: 3rem;
  margin-right: 1rem;
  width: 3rem;
`;

const TrackedContainer = withTrackingPropsProvider(styled.div``);

const TRACKING_PROPS = {
  block_name: 'account_drawer',
  block_row: 'account_drawer',
};

export class AccountDrawer extends Component {
  static propTypes = {
    close: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool,
    logout: PropTypes.func,
    isOpen: PropTypes.bool,
    openLogInModal: PropTypes.func,
    accountDisplayName: PropTypes.string,
    accountEmail: PropTypes.string,
  };

  static defaultProps = {
    isLoggedIn: false,
    isOpen: false,
  };

  render() {
    const {
      close,
      isOpen,
      isLoggedIn,
      logout,
      accountDisplayName,
      accountEmail,
      openLogInModal,
      openSignUpModal,
    } = this.props;

    const loggedIn = (
      <Item>
        <Profile>
          <LoggedInIcon>
            <User />
          </LoggedInIcon>
          <Info>
            <UserName>{accountDisplayName}</UserName>
            <Email>{accountEmail}</Email>
          </Info>
        </Profile>
      </Item>
    );

    const loggedOut = (
      <div>
        <Item onClick={openLogInModal}>
          <Icon>
            <User />
          </Icon>
          <p>Log in to your account</p>
        </Item>
        <Container>
          <TextContainer>
            <Header>Welcome to Paperless Post!</Header>
            <Paragraph>
              <Image src={envelope} />
              Sign up today to send your first few invitations or cards for
              free.
            </Paragraph>
          </TextContainer>
          <Button onClick={openSignUpModal}>Sign up</Button>
        </Container>
      </div>
    );

    const logoutNav = (
      <Nav>
        <SmallcapsHeader>my account</SmallcapsHeader>
        <LinkWrapper>
          <Link identifier="account-postbox-sent" href="/m/#/postboxes/sent">
            Sent
          </Link>
          <Link
            identifier="account-postbox-received"
            href="/m/#/postboxes/received"
          >
            Received
          </Link>
        </LinkWrapper>
        <LinkWrapper>
          <Link href="/flyer/manage">My Flyers</Link>
        </LinkWrapper>
        <LinkWrapper>
          <Logout className="logout" onClick={logout}>
            Logout
          </Logout>
        </LinkWrapper>
      </Nav>
    );

    return (
      <TakeoverDrawer
        direction="right"
        maxWidth="22.5rem"
        open={isOpen}
        overlayClick={close}
        overlayColor="rgba(51, 51, 51, 0.2)"
      >
        <TrackedContainer tracking={TRACKING_PROPS}>
          <DrawerItems>{isLoggedIn ? loggedIn : loggedOut}</DrawerItems>

          {isLoggedIn ? logoutNav : null}
        </TrackedContainer>
      </TakeoverDrawer>
    );
  }
}

export const AccountDrawerTakeover = takeover(AccountDrawer, 'isOpen');

const mapStateToProps = ({ account, account: { drawerOpen } }) => {
  return {
    accountDisplayName: accountDisplayName(account),
    accountEmail: accountEmail(account),
    isOpen: drawerOpen,
    isLoggedIn: isLoggedIn(account),
  };
};

const mapDispatchToProps = {
  close: closeAccountDrawer,
  logout,
  openSignUpModal,
  openLogInModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountDrawerTakeover);
